import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'

// 省市二级列表（H5）
export function listRegionForH5(data) {
  return request({
    url: `${apiConfig.SCM}/elemeUnionRecharge/listRegionForH5`,
    method: 'post',
    data
  })
}

// 门店列表查询（H5）
export function listStoreForH5(data) {
  return request({
    url: `${apiConfig.SCM}/elemeUnionRecharge/listStoreForH5`,
    method: 'post',
    data
  })
}
